import Model from '@/classes/Model'

export default class Status extends Model {
}
